import { InscriptionModel } from '@modules/inscription/inscription-model';

const { fields } = InscriptionModel;

export default [
    fields.id,
    fields.name,
    fields.lastName,
    fields.uid,
    fields.teams,
    fields.createdAt
];